import { hasCheckedIntegration, showOAuthLoading, currentPlatformId, oauthStatus } from '../state'

/**
 * Checks for pending integration in the URL query parameters
 * @param {Object} route - Vue Router route instance passed from parent
 * @param {Function} handleOAuthResponseFn - Function to handle OAuth response
 */
export const checkPendingIntegration = (route, handleOAuthResponseFn) => {
  if (hasCheckedIntegration.value) return

  let { integration: integrationCode, tab, scope } = route.query
  const integration = Number(integrationCode)

  // Detect OAuth process
  if (integration && tab && (route.query.code || route.hash || scope)) {
    // Show loading overlay immediately
    currentPlatformId.value = integration
    showOAuthLoading.value = true
    oauthStatus.value = 'connecting'
    
    // Prepare auth params
    let params = {}
    if (integration === 1) {
      // Instagram/Meta uses different auth flow with hash
      params = getMetaAuthParams(route)
    } else {
      const { code } = route.query
      params = { code }
    }
    
    // Process OAuth response
    if (integration && tab) {
      handleOAuthResponseFn(integration, params)
      hasCheckedIntegration.value = true
    }
  }
}

/**
 * Extracts Meta auth parameters from URL hash
 * @param {Object} route - Vue Router route instance
 * @returns {Object} Auth parameters
 */
const getMetaAuthParams = (route) => {
  const hash = route.hash.slice(1)
  
  return hash.split('&').reduce((acc, curr) => {
    const [key, value] = curr.split('=')
    acc[key] = decodeURIComponent(value)
    return acc
  }, {})
}